import { useSelector } from "react-redux";

import Mini from "/components/common/product/mini";
import PopupFormWrapper from "../popupFormWrapper";
import { GOALS } from "../../../../utils/tracking";

const FORM_CODE = "subscribeProduct";

export default function SubscribeProduct() {
  const { data } = useSelector((state) => state.popup);

  return (
    <PopupFormWrapper
      code={FORM_CODE}
      filterField={({ CODE }) => CODE !== "form_text_25"}
      goalOpen={GOALS.subscribeProductOpen}
      extraData={({ popupData }) =>
        popupData?.name ? { form_text_25: popupData.name } : null
      }
      successText={(r) =>
        `При поступлении товара вам поступит уведомление на почту. Номер заявки #${r.success}`
      }
      goalSent={GOALS.subscribeProductSent}
    >
      <Mini productId={data?.id} />
    </PopupFormWrapper>
  );
}
